import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useEffect, useRef } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { useDismissableNotification } from './useDismissableNotification';
export const Duration = {
    XS: 2000,
    S: 2500,
    M: 6000,
    XL: 10000
};
function getDuration(isMultiline = false, actionCount = 0) {
    if (!isMultiline) {
        if (!actionCount) {
            return Duration.XS;
        }
        if (actionCount === 1) {
            return Duration.S;
        }
        return Duration.M;
    }
    return Duration.XL;
}
const Notification = ({ id , onOpen: onOpenCallback , onClose: onCloseCallback , queueName , cardComponent: NotificationCard , cardProps ={} , children  })=>{
    const immortalNotifications = useFlag('yumeruby');
    const customDuration = cardProps.hasOwnProperty('duration');
    const { onClose , onPause , onUnpause  } = useDismissableNotification({
        id,
        queueName,
        duration: immortalNotifications ? 9999999 : customDuration ? cardProps.duration : getDuration(cardProps.multiLine, cardProps.actions && cardProps.actions.length),
        onCloseCallback
    });
    const rootRef = useRef(null);
    useEffect(()=>{
        rootRef.current && onOpenCallback && onOpenCallback(id, rootRef.current);
    }, [
        id,
        onOpenCallback
    ]);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Notifcation"
    }, /*#__PURE__*/ React.createElement(NotificationCard, _extends({}, cardProps, {
        rootRef: rootRef,
        onClose: onClose,
        onMouseEnter: onPause,
        onMouseLeave: onUnpause
    }), children));
};
Notification.displayName = 'Notification';
export default Notification;
